
import {
    Vue,
    Component,
    Prop,
} from 'vue-property-decorator';
import InputCheckbox from '@/components/input/InputCheckbox.vue';
import { DailyWageReport, WeeklyReport } from '@/clients/omb-api';
import InputButton from '@/components/input/InputButton.vue';
import ConnectionUtils from '@/assets/ts/connection_utils';
import Service from '@/services/Service';

@Component({
    components: {
        InputButton,
        InputCheckbox,
    },
})
export default class ReportCard extends Vue {

    @Prop()
    private weeklyReport?: WeeklyReport;

    @Prop()
    private dailyWageReport?: DailyWageReport;

    @Prop()
    private title?: string;

    @Prop()
    private action?: () => void;

    @Prop()
    private online: boolean | undefined;

    private isOnline = false;
    private uploading = false;

    private get computedTitle(): string {
        if (this.title) return this.title;
        return this.weeklyReport?.week || this.dailyWageReport?.number || '-';
    }

    private get canBeUploaded(): boolean {
        const report = this.weeklyReport || this.dailyWageReport;
        return !!(
            report
            && report.offline
            && report.offlineId
            && report.signature
            && !report.fileId
        );
    }

    private mounted(): void {
        if (this.online === undefined) {
            this.isOnline = ConnectionUtils.addConnectionChangeListener((status) => this.isOnline = status);
        } else {
            this.isOnline = this.online;
        }
    }

    private doAction() {
        if (this.action) {
            this.action();
        } else {
            this.$emit('action');
        }
    }

    private doUploadAction() {
        if (this.weeklyReport) {
            this.uploading = true;
            const isNew = !this.weeklyReport.id;
            Service.reports.saveWeeklyReport(this.weeklyReport)
                .then((result) => {
                    if (!result.remoteError) {
                        this.$emit(isNew ? 'upload' : 'update', result.report);
                    }
                })
                .finally(() => this.uploading = false);
        } else if (this.dailyWageReport) {
            this.uploading = true;
            const isNew = !this.dailyWageReport.id;
            Service.reports.saveDailyWageReport(this.dailyWageReport)
                .then((result) => {
                    if (!result.remoteError) {
                        this.$emit(isNew ? 'upload' : 'update', result.report);
                    }
                })
                .finally(() => this.uploading = false);
        }
    }

}
